module.exports = __webpack_public_path__ + "img/multiplier_1.f949bbec.png";